import { render, staticRenderFns } from "./DocumentPortalSetupLinkView.vue?vue&type=template&id=b0e0d8a0&scoped=true&"
import script from "./DocumentPortalSetupLinkView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupLinkView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupLinkView.vue?vue&type=style&index=0&id=b0e0d8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0d8a0",
  null
  
)

export default component.exports